import React from 'react';

import { useParams } from 'react-router-dom';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import BundleFilterForm from './components/BundleFilterForm';

type Props = {
  vendorId: string;
};

function BundlesFilterCreate({ vendorId }: Props) {
  const { bundleId } = useParams<{ bundleId: string }>();

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Add Bundle Filter</DialogTitle>
      <DialogContent>
        <BundleFilterForm bundleId={bundleId} vendorId={vendorId} />
      </DialogContent>
    </Dialog>
  );
}

export default BundlesFilterCreate;
